import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=658c2deb&scoped=true&"
import script from "./TemplateItem.vue?vue&type=script&lang=js&"
export * from "./TemplateItem.vue?vue&type=script&lang=js&"
import style0 from "../Style/template-item.scss?vue&type=style&index=0&id=658c2deb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658c2deb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('658c2deb')) {
      api.createRecord('658c2deb', component.options)
    } else {
      api.reload('658c2deb', component.options)
    }
    module.hot.accept("./TemplateItem.vue?vue&type=template&id=658c2deb&scoped=true&", function () {
      api.rerender('658c2deb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplateItem.vue"
export default component.exports